import axios from '@/services/api'

/**
 * @param {Object} credentials
 *
 * @returns {Promise<Object>}
 */
export const login = (credentials) => axios.post('/api/users/login', credentials)

/**
 * @param {Object} payload
 *
 * @returns {Promise<Object>}
 */
export const register = (payload) => axios.post('/api/users/registration', payload)

/**
 *
 * @returns {Promise<Object>}
 */
export const logout = () => axios.post('/api/users/logout')

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */

export const socialLogin = (data) => axios.post('/api/social/auth', data)

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const restorePassword = (data) => axios.post('/api/users/restore-password', data)